/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

var coll = document.querySelectorAll(".mak-collapsible");
var i;

for (i = 0; i < coll.length; i++) {
  coll[i].addEventListener("click", function () {
    var content = this.parentElement.nextElementSibling;
    var svg = this.querySelector(".mak-rotate");

    this.classList.toggle("active");

    if (content.style.maxHeight) {
      content.style.maxHeight = null;
      svg.style.transform = ""; // Reset the transform when closed
    } else {
      content.style.maxHeight = content.scrollHeight + "px";
      svg.style.transform = "rotate(180deg)"; // Apply the transform when open
    }
  });
}

$(function () {
  if (window.matchMedia("(max-width: 768px)").matches) {
    $(".mak-slide").slick({
      dots: true,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      arrows: false,
    });
  }
});
$(function () {
  if (window.matchMedia("(max-width: 768px)").matches) {
    $(".ar-mbl-slider").slick({
      dots: true,
      infinite: true,
      speed: 300,
      slidesToShow: 2,
      slidesToScroll: 1,
      autoplay: true,
      arrows: false,
    });
  }
});

$(document).ready(function () {
  $(".smooth").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 8000,
    pauseOnHover: false,
    arrows: false,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2.5,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1.25,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.65,
          slidesToScroll: 1,
        },
      },
    ],
  });
});
